import React, { useEffect, useState } from "react";
import SurveyListHeader from "../../../component/layout/MainHeader";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Svg from "../../../component/Svg";
import Input from "../../../core/Inputs/DefaultInput";
import { groupBy } from 'lodash';

import { toast } from "react-toastify";
import { performHttpRequest } from "../../../../axios/PerformHttpRequest";
import Select from "react-select/creatable";
import { useSelector } from "react-redux";
import { getTokenData } from '../../../store/actions/authAction'
export default function CreateTemplate({ getUserData }) {
  const apiUrl = process.env.REACT_APP_NODE_API_URL;
  const navigate = useNavigate();
  const loggedInUserDetail = useSelector(
    (state) => state.userData.loggedInUserDetail
  );

  const [roiProjectName, setRoiProjectName] = useState("");
  const [landingPage, setLandingPage] = useState([]);
  const [reportType, setReportType] = useState("Vertical");
  const [roiLanguage, setRoiLanguage] = useState([]);
  const [roiCurrency, setRoiCurrency] = useState([]);
  const [configurationError,setConfigurationError]=useState('');
  const [primaryCurrency, setPrimaryCurrency] = useState([]);
  const [additionaCurrency, setAdditionalCurrency] = useState([]);
  const [defaultLanguage, setDefaultLanguage] = useState([]);
  const [countryChange, setCountryChange] = useState([]);
  const [roiTemplateType, setRoiTemplateType] = useState([]);
  const [roi_template_id, setRoiTemplateId] = useState([]);
  const [structure, setStructure] = useState([]);
  const [acceptDecimals, setAcceptDecimals] = useState(1);

  //error validations states @amit
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');
  const [errorTemplate, setErrorTemplate] = useState('');
  const [errorLanguage, setErrorLanguage] = useState('');
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [countriesError, setCountriesError] = useState('');
  const [selectedCurrency, setSelectedCurrency] = useState([]);
  const [currencyError, setCurrencyError] = useState('');
  const [userId, setuserId] = useState('');
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getTokenData(setuserId));
  }, [dispatch]);

  useEffect(() => {
    getLanguageCurrencyAndTemplateDetail();
  }, []);

  useEffect(() => {
    if (loggedInUserDetail) {
      //console.log("Logged In User Details:", loggedInUserDetail);
    }
  }, [loggedInUserDetail]);

  const getLanguageCurrencyAndTemplateDetail = async () => {
    setConfigurationError('');
    try {
      const response = await performHttpRequest(
        "GET",
        `${apiUrl}/roi/roiLanguage&Currency`,
        ""
      );
      const templateResponse = await performHttpRequest(
        "GET",
        `${apiUrl}/roi/roiTemplate`,
        ""
      );
      //console.log("templateResponse", templateResponse);
      if(!Array.isArray(response?.data?.languageResult)||!Array.isArray(response?.data?.currencyResult)||!Array.isArray(templateResponse?.data?.template))throw Error('Calculator configuration did not load.');
      setRoiTemplateType(templateResponse.data.template);
      setRoiLanguage(response.data.languageResult);
      setRoiCurrency(response.data.currencyResult);
    } catch (error) {
      //console.error("Error", error);
      const message=error?.response?.data?.responseText||error.message||'Unable to load calculator configuration.';
      setConfigurationError(message);
      toast.error(message);
    }
  };

  //console.log("land", landingPage);

  const handleLandingPageChange = (e, template) => {
    const { roi_template_page_id: id, roi_template_name, structure: templateStructure, roi_template_type_id } = template;
    const isChecked = e.target.checked;
  
    if (isChecked) {
      setRoiTemplateId([...roi_template_id, id]);
      setLandingPage([...landingPage, roi_template_name]);
      setStructure([...structure, { id, page_type: roi_template_name, structure: templateStructure, roi_template_type_id }]);
    } else {
      setRoiTemplateId(roi_template_id.filter((item_id) => item_id !== id));
      const newStructure = structure.filter((item) => item.id !== id);
      const newLandingPage = newStructure.map(item => item.page_type);
      setStructure(newStructure);
      setLandingPage(newLandingPage);
    }
  };

  const handlePrimaryCurrencyChange = (selectedOption) => {
    const selectedPrimaryCurrency = selectedOption?.map(
      (option) => option.value
    );
    setPrimaryCurrency(selectedPrimaryCurrency);
    setSelectedCurrency(selectedOption);
    if (currencyError && selectedOption.length > 0) setCurrencyError('');
  };

  const handleCountryChange = (selectedOption) => {
    const selectedCountryChange = selectedOption?.map((option) => option.value);
    setCountryChange(selectedCountryChange);
    setSelectedCountries(selectedOption);
    if (countriesError && selectedOption.length > 0) setCountriesError('');
  };

  const handleAdditionalCurrencyChange = (selectedOption) => {
    const selectedAdditionalCurrency = selectedOption?.map(
      (option) => option.value
    );
    setAdditionalCurrency(selectedAdditionalCurrency);
  };

  const hanldleDefaultLanguageChange = (selectedOption) => {
    const selectedDefaultLanguage = selectedOption?.value;
    setDefaultLanguage(selectedDefaultLanguage);
  };

  const handleChange = (e) => {
    setRoiProjectName(e.target.value);
    setInputValue(e.target.value);
    if (error && e.target.value.trim()) setError('');
  };

  const handleReportChange = (e) => {
    const reportType = e.target.value;
    setReportType(reportType);
  };

  const handleRoiSubmit = async (e) => {
    e.preventDefault();
    try {
      let valid = true;

      if (!inputValue.trim()) {
        setError('This field is required.');
        valid = false;
      } else {
        setError('');
      }

      if (selectedCountries.length === 0) {
        setCountriesError('At least one country must be selected.');
        valid = false;
      } else {
        setCountriesError('');
      }

      if (selectedCurrency.length === 0) {
        setCurrencyError('At least one currency must be selected.');
        valid = false;
      } else {
        setCurrencyError('');
      }
      
      if (roi_template_id.length === 0) {
        setErrorTemplate('At least one template must be selected.');
        valid = false;
      } else {
        setErrorTemplate('');
      }
      //console.log("defaultLanguage", defaultLanguage);
      if(defaultLanguage.length === 0) {
        setErrorLanguage('At least one language must be selected.');
        valid = false;
      } else {
        setErrorLanguage('');
      }

      if (valid) {
        const structures = structure.map(
          ({ id, roi_template_type_id, ...rest }) => rest
        );
        const roiTemplateTypeIds = [...new Set(structure.map(item => item.roi_template_type_id))];
        
        const response = await performHttpRequest(
          "POST",
          `${apiUrl}/roi/addRoi`,
          {
            roi_name: roiProjectName,
            primary_currency: primaryCurrency,
            additional_currency: additionaCurrency,
            default_language: defaultLanguage,
            page_type: landingPage,
            report_type: reportType,
            country_name: countryChange,
            roi_template_type_id: roiTemplateTypeIds,
            structure: structures,
            added_by: userId,
            accept_decimals: acceptDecimals
          }
        );

        if (response?.data?.statusCode === 200) {
          toast.success(response?.data?.msg);
          navigate("/admin/roi");
        } else {
          toast.error(response?.data?.msg);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.msg);
    }
  };


  // Grouping the ROI templates by roiTemplateType
  const groupedItems = groupBy(roiTemplateType, 'roi_template_type_id');

  return (
    <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
      <SurveyListHeader />
      <div id="viewport" className="d-flex">
        <SurveyListSidebar />
        <div className="flex-grow-1 d-flex">
          <div className="dashboard-page-outer flex-grow-1">
            <div className="custom-breadcrumb">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link
                      to="/admin/roi"
                      className="home-item"
                      title="Dashboard"
                    >
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    <strong>Create ROI Calculator</strong>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="page-content-wrap create-roi-template">
              <div className="new-survery-screen ai-survery-screen m-0">
                <div className="container">
                  <div className="text-icon-wrapper">
                    <h1 className="text-primary mb-0">
                      Create your ROI Calculator
                    </h1>
                    <p>
                      Provide a few details to configure the settings of your
                      calculator
                    </p>
                  </div>

                  <div className="field-wrapper">
                    {configurationError && <div className="alert alert-danger" role="alert">{configurationError} <button type="button" className="btn btn-link" onClick={getLanguageCurrencyAndTemplateDetail}>Try again</button></div>}
                    <div className="form-group name-field">
                      <label className="form-label-custom">
                        Please enter the name of your project{" "}
                        <span className="req">*</span>
                      </label>
                      <div className="position-relative">
                        <Input
                          type="text"
                          view="outlined"
                          color="default"
                          label=""
                          placeholder="Enter your ROI Calculator name"
                          fill
                          className="formsinput"
                          value={inputValue}
                          onChange={handleChange}
                        />
                      </div>
                      {error && <div style={{ color: 'red' }}>{error}</div>}
                    </div>

                    <div className="general-questions">
                      <div className="form-group">
                        <label className="form-label-custom">
                          For which countries is this calculator applicable?{" "}
                          <span className="req">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="custom-select"
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            isMulti={true}
                            options={roiCurrency?.map((item) => ({
                              value: item.country_name,
                              label: item.country_name,
                            }))}
                            onChange={handleCountryChange}
                            value={selectedCountries}
                            styles={{
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: "#ffcccb", // Change background color to red
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                color: "red", // Change text color to white
                              }),
                              multiValueRemove: (provided) => ({
                                ...provided,
                                color: "red", // Change the color of the close icon to red
                              }),
                            }}
                          />
                          {countriesError && <div style={{ color: 'red' }}>{countriesError}</div>}
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label-custom ">
                          What is the primary currency for your calculator?
                          <span className="text-primary">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            className="custom-select"
                            classNamePrefix="select"
                            isClearable
                            isMulti={true}
                            options={roiCurrency?.map((item) => ({
                              value: item.currency_name,
                              label: item.currency_name,
                            }))}
                            onChange={handlePrimaryCurrencyChange}
                            value={selectedCurrency}
                            styles={{
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: "#ffcccb", // Change background color to red
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                color: "red", // Change text color to white
                              }),
                              multiValueRemove: (provided) => ({
                                ...provided,
                                color: "red", // Change the color of the close icon to red
                              }),
                            }}
                          />
                          {currencyError && <div style={{ color: 'red' }}>{currencyError}</div>}
                        </div>
                      </div>

                      <div className="form-group">
                        <label className="form-label-custom ">
                          Which additional currencies would you like to include
                          for your calculator?
                        </label>
                        <div className="position-relative">
                          <Select
                            className="custom-select"
                            classNamePrefix="select"
                            isClearable
                            isMulti={true}
                            options={roiCurrency?.map((item) => ({
                              value: item.currency_name,
                              label: item.currency_name,
                            }))}
                            onChange={handleAdditionalCurrencyChange}
                            styles={{
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: "#ffcccb", // Change background color to red
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                color: "red", // Change text color to white
                              }),
                              multiValueRemove: (provided) => ({
                                ...provided,
                                color: "red", // Change the color of the close icon to red
                              }),
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label className="form-label-custom ">
                          Select the default language for your calculator
                          <span className="text-primary">*</span>
                        </label>
                        <div className="position-relative">
                          <Select
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            onChange={hanldleDefaultLanguageChange}
                            menuPortalTarget={document.body}
                            className="custom-select"
                            classNamePrefix="select"
                            isClearable
                            options={roiLanguage?.map((item) => ({
                              value: item.language_name,
                              label: item.language_name,
                            }))}
                          />
                        </div>
                        {errorLanguage && <div style={{ color: 'red' }}>{errorLanguage}</div>}
                      </div>
                    </div>

                    {Object.keys(groupedItems).map(roiTemplateType => (
                      <div key={roiTemplateType}>
                        <div
                          key={groupedItems[roiTemplateType][0].roi_template_page_id}
                          className="select-page-type"
                          style={{ borderTop: "none" }}
                        >
                          <div className="page-list">
                            <div className="heading">
                              <h5>{groupedItems[roiTemplateType][0].roi_template_name}</h5>
                              <p>{groupedItems[roiTemplateType][0].roi_template_desc}</p>
                            </div>
                            <div className="row gx-12px">
                              {groupedItems[roiTemplateType].map(item => (
                                <div key={item.roi_template_page_id} className="col-lg-3 col-md-4 col-sm-6">
                                  <div className="temp-wrap">
                                    <input
                                      id={`view${item.roi_template_page_id}`}
                                      className="form-check-input"
                                      type="checkbox"
                                      value={item.roi_template_name}
                                      onChange={(e) => handleLandingPageChange(e, item)}
                                      checked={roi_template_id.includes(item.roi_template_page_id)}
                                    />
                                    <label
                                      htmlFor={`view${item.roi_template_page_id}`}
                                      className="img-wrapper"
                                    >
                                      <img
                                        src={item.roi_template_page_img.replace(".", "")}
                                        alt={item.roi_template_name}
                                      />
                                    </label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                        {/* Check if the template type is "Savings Report" */}
                        {groupedItems[roiTemplateType][0].roi_template_name === "Savings Report" && (
                          <div className="report-type" style={{ marginBottom: '20px' }}>
                            <h6><strong>Report Orientation Type</strong></h6>
                            <div className="form-check form-check-inline ps-0">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`reportType${groupedItems[roiTemplateType][0].id}`}
                                id={`Vertical${groupedItems[roiTemplateType][0].id}`}
                                value="Vertical"
                                defaultChecked
                                onChange={handleReportChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`Vertical${groupedItems[roiTemplateType][0].id}`}
                              >
                                Vertical
                              </label>
                            </div>
                            <div className="form-check form-check-inline ps-0">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`reportType${groupedItems[roiTemplateType][0].id}`}
                                id={`Horizontal${groupedItems[roiTemplateType][0].id}`}
                                value="Horizontal"
                                onChange={handleReportChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`Horizontal${groupedItems[roiTemplateType][0].id}`}
                              >
                                Horizontal
                              </label>
                            </div>
                          </div>
                        )}
                        
                      </div>
                      
                    ))}
                    

                    {errorTemplate && <div style={{ color: 'red' }}>{errorTemplate}</div>}
                    <div className="form-group gap-4" style={{ marginTop: '20px' }}>
                      <label className="form-label-custom">
                        Do you want the calculation to support decimal values?
                      </label>
                      <div className="d-flex gap-4">
                        <div className="form-check" style={{ paddingLeft: '0' }}>
                          <input
                            type="radio"
                            className="form-check-input"
                            id="decimalsYes"
                            name="acceptDecimals"
                            value={1}
                            checked={acceptDecimals === 1}
                            onChange={(e) => setAcceptDecimals(Number(e.target.value))}
                          />
                          <label className="form-check-label" htmlFor="decimalsYes">
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="decimalsNo"
                            name="acceptDecimals"
                            value={0}
                            checked={acceptDecimals === 0}
                            onChange={(e) => setAcceptDecimals(Number(e.target.value))}
                          />
                          <label className="form-check-label" htmlFor="decimalsNo">
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className="button-wrap d-flex flex-wrap justify-content-center gap-3">
                      <button
                        className="btn btn-bordered"
                        onClick={() => navigate("/admin/roi")}
                      >
                        {" "}
                        Cancel{" "}
                      </button>

                      <button
                        className="d-inline-flex align-items-center btn roi-btn-primary"
                        onClick={handleRoiSubmit}
                      >
                        <span className="with-icon">Continue</span>
                        <div className="icon">
                          <Svg name="roi-button-arrow" />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
